import { cloneDeep } from "lodash-es";
import { CashFlow } from "./cashflow/cash-flow.model";
import { DebtScheduleInterface, makeDebtSchedule } from "./debt-schedule.model";
import { EAFM } from "./eafm/eafm.model";
import { ISPL } from "./ispl/ispl.model";

export interface FinancialResultsInterface {
 'RESULTS.DATA.EAFM'?: EAFM
 'RESULTS.DATA.CASH_FLOW'?: CashFlow;
 'RESULTS.DATA.ISPL.TITLE'?: ISPL;
 'RESULTS.DATA.DEBT_SCHEDULE'?: DebtScheduleInterface;
}

export class FinancialResults {
  'RESULTS.DATA.EAFM';
  'RESULTS.DATA.DEBT_SCHEDULE';
  'RESULTS.DATA.ISPL.TITLE';
  'RESULTS.DATA.CASH_FLOW';

  /** economic and financial metrics */
  get eafm() {
    return this['RESULTS.DATA.EAFM'];
  }
  set eafm(value: EAFM) {
    this['RESULTS.DATA.EAFM'] = value;
  }
  get cashFlow() {
    return this['RESULTS.DATA.CASH_FLOW'];
  }
  set cashFlow(value: CashFlow) {
    this['RESULTS.DATA.CASH_FLOW'] = value;
  }
  get ispl() {
    return this['RESULTS.DATA.ISPL.TITLE'];
  }
  set ispl(value: ISPL) {
    this['RESULTS.DATA.ISPL.TITLE'] = value;
  }
  get debtSchedule() {
    return this['RESULTS.DATA.DEBT_SCHEDULE'];
  }
  set debtSchedule(value: DebtScheduleInterface) {
    this['RESULTS.DATA.DEBT_SCHEDULE'] = value;
  }

  constructor(param: FinancialResultsInterface = {}) {
    this['RESULTS.DATA.EAFM'] = param['RESULTS.DATA.EAFM']
      ? new EAFM(param['RESULTS.DATA.EAFM'])
      : new EAFM();

    this['RESULTS.DATA.CASH_FLOW'] = param['RESULTS.DATA.CASH_FLOW']
      ? new CashFlow(param['RESULTS.DATA.CASH_FLOW'])
      : new CashFlow();

    this['RESULTS.DATA.ISPL.TITLE'] = param['RESULTS.DATA.ISPL.TITLE']
      ? new ISPL(param['RESULTS.DATA.ISPL.TITLE'])
      : new ISPL();

    this['RESULTS.DATA.DEBT_SCHEDULE'] = param['RESULTS.DATA.DEBT_SCHEDULE']
      ? makeDebtSchedule(param['RESULTS.DATA.DEBT_SCHEDULE'])
      : makeDebtSchedule();
  }

  deepCopy() {
    return new FinancialResults(cloneDeep(this));
  }
}
